import { schema } from 'normalizr';
import { MentoringProgramGuide } from '../models/mentoring-program-guides';

export const MentorshipProgramGuideSchema = new schema.Entity<MentoringProgramGuide>('mentorshipProgramGuides');

export const MentorshipProgramGuidesSchema = new schema.Array(
  MentorshipProgramGuideSchema,
);
